import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-4 p-4 bg-white max-w-[600px] w-80 lg:w-96 border rounded shadow-lg absolute right-[-140px] lg:right-0 top-8 max-h-96 overflow-y-scroll"
}
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "font-bold" }, "Notificaciones", -1)
const _hoisted_5 = { class: "text-black text-sm" }
const _hoisted_6 = { class: "flex justify-between items-baseline" }
const _hoisted_7 = { class: "text-sm font-light" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "text-left uppercase text-sm"
}
const _hoisted_10 = { class: "text-sm text-gray-600" }
const _hoisted_11 = { class: "text-sm flex justify-between items-baseline" }
const _hoisted_12 = { class: "font-light text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mdicon, {
      class: "cursor-pointer hover:text-light-green text-white",
      name: _ctx.notificationIconName,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenu()))
    }, null, 8, ["name"]),
    (_ctx.menuIsVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendReadAllNotifications()))
            }, "Marcar todas leidas")
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unreadNotifications, (notification, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "text-left hover:bg-[#9BB44157]"
            }, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(notification.message), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.reformatDate(notification.createdAt)), 1),
                _createElementVNode("span", {
                  class: "bg-primary-green px-2 py-0.5 rounded-full font-bold text-white text-xs uppercase hover:bg-primary-green/80 cursor-pointer",
                  onClick: ($event: any) => (_ctx.sendReadNotification(notification.id))
                }, " Nuevo ", 8, _hoisted_8)
              ])
            ]))
          }), 128)),
          (_ctx.readedNotifications.length > 0)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_9, "Notificaciones leidas"))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.readedNotifications, (notification, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "text-left text-gray-400 hover:bg-[#9BB44157]"
            }, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(notification.message), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.reformatDate(notification.createdAt)), 1)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.clickOutside]
  ])
}